import {Component, OnInit, Input, ElementRef, Output, EventEmitter, OnDestroy, OnChanges, ViewChildren} from '@angular/core';
import { ValidatorUtils } from '../../../shared/utils/src/validator.utils';
import { StringUtils } from '../../../shared/utils/src/string.utils';
import * as _ from 'lodash';
import { DragulaService } from 'ng2-dragula';
import {ServiceServices} from '../../../shared/services/src/api';

@Component({
    selector: 'escalation-route-rule-component',
    templateUrl: './escalation-route-rule.component.html'
})

export class EscalationRouteRuleComponent implements OnInit, OnDestroy, OnChanges{
    @Input() public routeRuleInfos = [];
    @Input() public isRolePrms = true;
    @Output() public routeNotUse: EventEmitter<any> = new EventEmitter();
    @Output() public ruleSetOrders: EventEmitter<any> = new EventEmitter<any>();
    @Output() public ruleSetEdit: EventEmitter<any> = new EventEmitter<any>();
    @Output() public ruleSetRemove: EventEmitter<any> = new EventEmitter<any>();

    cndVal: string;
    ruleIndex = 0;

    ruleSet = {
        dispNm: ''
    };

    constructor(public element: ElementRef,
                private serviceServices: ServiceServices,
                private dragulaService: DragulaService) {

        dragulaService.drop.subscribe((value: any) => {
            if (value[0] === 'routingRules') {
                if (this.routeRuleInfos.length > 1) {
                    this.emitRuleOrderInfo();
                }
            }
        });

        dragulaService.setOptions('routingRules', {
            moves: function (el, container, handle) {
                return handle.className === 'dragable_button dragable_flag';
            }
        });
    }

    ngOnInit() {}

    ngOnDestroy() {
        this.dragulaService.destroy('routingRules');
    }

    ngOnChanges() {

    }

    public ruleSetRemovePopup(ruleSet) {
        this.ruleSet = ruleSet;
        this.openPopUp('#routingRuleDelete');
    }

    public emitRuleOrderInfo(): any {
        let ruleOrders = [];

        $('#routeRuleInfos tbody tr').each(function (idx) {
            const ruleOrder = {
                ruleRoutGrpNo: Number($(this).find('[name=ruleRoutGrpNo]').val()),
                ordrNo: idx + 1
            }
            ruleOrders.push(ruleOrder);
        });

        this.ruleSetOrders.emit(ruleOrders);
    }

    openPopUp(src) {
        $.magnificPopup.open({
            items: {
                src: src
            },
        });
    }

    edit(ruleSet) {
        this.ruleSetEdit.emit(ruleSet);
    }

    ruleSetDelete() {
        this.ruleSetRemove.emit(this.ruleSet);
    }

    cancel() {
        $.magnificPopup.close();
    }

}



// WEBPACK FOOTER //
// ./src/app/components/ruleSet/escalation-route-rule/escalation-route-rule.component.ts